module.exports = "<div class=\"modal fade q-modal q-default-base q-default q-reset q-text-center\" role=dialog> <div class=\"modal-dialog q-modal-dialog-500\"> <div class=modal-content> <div class=modal-body> <div class=q-pad-all-xl> <h1 class=\"q-title q-no-marg\">{%- optional.title %}</h1> <div class=\"q-pad-top-lg q-pad-bottom-sm\">{%= optional.body %}</div> </div> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/SubmitModalFlow/html/alertModal.html
// module id = 177
// module chunks = 1